var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEpo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1169 19.4453C33.2142 19.4453 34.5195 18.008 34.5195 15.7053C34.5195 13.4026 33.2142 11.9653 31.1169 11.9653C29.0195 11.9653 27.7142 13.4026 27.7142 15.7053C27.7142 18.008 29.0195 19.4453 31.1169 19.4453ZM25.4849 15.7053C25.4849 12.376 27.8169 10.0293 31.1169 10.0293C34.4169 10.0293 36.7489 12.376 36.7489 15.7053C36.7489 19.0346 34.4169 21.3813 31.1169 21.3813C27.8169 21.3813 25.4849 19.0346 25.4849 15.7053Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4533 16.0133C22.5093 16.0133 23.1693 15.2506 23.1693 14.0333C23.1693 12.8159 22.5093 12.0533 21.4533 12.0533H18.8573V16.0133H21.4533ZM16.6279 21.2639V10.1466H21.5266C23.7999 10.1466 25.3986 11.7453 25.3986 14.0333C25.3986 16.3213 23.7999 17.9199 21.5266 17.9199H18.8573V21.2639H16.6279Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3471 10.1466V12.0533H9.40707V14.5906H14.5697V16.4973H9.40707V19.3573H15.3471V21.2639H7.17773V10.1466H15.3471Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEpo);
export default __webpack_public_path__ + "static/media/icon_epo.32387715a5fcc2e6910619cf3c2f12cb.svg";
export { ForwardRef as ReactComponent };